const json = require('./json');

module.exports = {
	...json,
	name: 'file'
};
